import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import translate from 'components/hoc/translate';

class MobianDateTimeInput extends React.Component {
    constructor(props) {
        super(props);

        const {
            input,
        } = props;

        // Set the initial state with the date
        let datetime = input.value && /([0-9]{4}-[0-9]{2}-[0-9]{2}) ([0-9]{2}):([0-9]{2})/.exec(props.input.value);

        this.state = {
            enteredDate: datetime ? datetime[1] : '',
            selectedHours: datetime ? datetime[2] : '',
            selectedMinutes: datetime ? datetime[3] : '',
        };
    }

    componentDidMount() {
        this.updateReduxState();
    }

    showValues = (type, maxAmount, steps = 1) => {
        const result = [];

        for (let i = 0; i < maxAmount; i += steps) {
            let value = i < 10 ? `0${ i }` : i;

            result.push(<MenuItem value={ `${ value }` } key={ `${ type }-${ i }` } primaryText={ `${ value }` } />);
        }

        return result;
    }

    /**
     * This function updates the the date.
     */
    handleDateChange = (event, date) => {
        const data = { enteredDate: date };

        this.setState(data);
        this.updateReduxState(data, event);
    }

    /**
     * This function updates the the hours.
     */
    handleChangeHours = (e) => {
        // Fetch the value of the dropdown and transform it to a Integer.
        const data = { selectedHours: e.target.innerText };

        this.setState(data);
        this.updateReduxState(data, e);
    }

    /**
     * This function updates the the minutes.
     */
    handleChangeMinutes = (e) => {
        // Fetch the value of the dropdown and transform it to a Integer.
        const data = { selectedMinutes: e.target.innerText };

        this.setState(data);
        this.updateReduxState(data, e);
    }

    /**
     * Update the Redux state.
     */
    updateReduxState = (options, event) => {
        options = options || {};

        let date = options.enteredDate || this.state.enteredDate;
        let hours = options.selectedHours || this.state.selectedHours;
        let minutes = options.selectedMinutes || this.state.selectedMinutes;

        if (!date && !hours && !minutes) {
            return this.props.input.onChange(null);
        }

        if (!hours.length) {
            hours = '00';
        }

        if (!minutes.length) {
            minutes = '00';
        }

        this.props.input.onChange(`${ date } ${ hours }:${ minutes }:00`, event);
    }

    render() {
        const { input, label, labelHours, labelMinutes, meta: { touched, error }, options, source, resource, disabled } = this.props;

        return (
            <div style={ { display: 'flex' } }>
                <TextField
                    { ...input }
                    errorText={ touched && error }
                    floatingLabelFixed={ true }
                    floatingLabelText={ <FieldTitle label={ label } source={ source } resource={ resource } /> }
                    value={ this.state.enteredDate }
                    onChange={ this.handleDateChange }
                    style={ { width: '300px' } }
                    disabled={ disabled }
                    type='date'
                    { ...options }
                />

                <SelectField
                    { ...input }
                    errorText={ touched && error }
                    floatingLabelText={ <FieldTitle label={ labelHours } /> }
                    value={ this.state.selectedHours }
                    onChange={ this.handleChangeHours }
                    maxHeight={ 200 }
                    style={ { width: '100px' } }
                    disabled={ disabled }
                >
                    { this.showValues('hours', 24) }
                </SelectField>

                <SelectField
                    { ...input }
                    errorText={ touched && error }
                    floatingLabelText={ <FieldTitle label={ labelMinutes } /> }
                    value={ this.state.selectedMinutes }
                    onChange={ this.handleChangeMinutes }
                    maxHeight={ 200 }
                    style={ { width: '100px' } }
                    disabled={ disabled }
                >
                    { this.showValues('minutes', 60, 5) }
                </SelectField>
            </div>
        );
    }
}

MobianDateTimeInput.defaultProps = {
    options: {},
    disabled: false,
    labelHours: 'hours',
    labelMinutes: 'minutes',
};

MobianDateTimeInput.propTypes = {
    disabled: PropTypes.bool.isRequired,
    elStyle: PropTypes.object,
    input: PropTypes.object,
    label: PropTypes.string,
    labelHours: PropTypes.string,
    labelMinutes: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.object,
    record: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
};

export default translate(MobianDateTimeInput);



// WEBPACK FOOTER //
// ./src/components/input/MobianDateTimeInput/index.js